/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */

import type { Interaction } from 'ol/interaction';
import { DragPan, DragRotate, MouseWheelZoom, PinchRotate, PinchZoom } from 'ol/interaction';
import type MapBrowserEvent from 'ol/MapBrowserEvent';
import type Map from 'ol/Map';
import { altKeyOnly } from 'ol/events/condition';

export interface Options {
  condition?: (ev: MapBrowserEvent) => boolean;
}

/**
 * This class contains interactions designed to be used in complement of drawing interactions
 */
export class MoveMapInteractionsBundle {
  private map?: Map;
  private interactions: Interaction[] = [];

  constructor(private options: Options) {}

  public setup(map: Map) {
    this.map = map;

    const condition = this.options.condition;

    this.interactions = [
      new DragRotate({ condition: (ev) => altKeyOnly(ev) }),
      new DragPan({ condition }),
      new PinchRotate(),
      new PinchZoom(),
      new MouseWheelZoom({ condition, onFocusOnly: false }),
    ];
    this.interactions.forEach((inter) => map.addInteraction(inter));
  }

  public dispose() {
    this.interactions.forEach((inter) => {
      inter.dispose();
      this.map?.removeInteraction(inter);
    });
  }
}
